export enum IntegrationApp {
    GoogleDrive = "google-drive",
    OneDrive = "one-drive",
}

export const isValidIntegrationApp = (appName: IntegrationApp): boolean =>
    appName === IntegrationApp.GoogleDrive || appName === IntegrationApp.OneDrive
